export default [
  {
    id: 'NAO_EXECUTOU',
    descricao: 'NÃO EXECUTOU',
    valor: 0,
    escala: 0,
    rating: 1,
  },
  {
    id: 'INSUFICIENTE',
    descricao: 'INSUFICIENTE',
    valor: 1,
    escala: 25,
    rating: 2,
  },
  {
    id: 'REGULAR',
    descricao: 'REGULAR',
    valor: 2,
    escala: 50,
    rating: 3,
  },
  {
    id: 'BOM',
    descricao: 'BOM',
    valor: 3,
    escala: 75,
    rating: 4,
  },
  {
    id: 'EXCELENTE',
    descricao: 'EXCELENTE',
    valor: 4,
    escala: 100,
    rating: 5,
  },
];
